import { SubscriptionTiers } from "@/components/SubscriptionTiers";

interface Props {
  open: boolean;
  onClose: () => void;
}

/**
 * Full-screen paywall modal shown when a user runs out of FIG Verify scans.
 * Wraps SubscriptionTiers in its `paywall` layout (plum + gold theme).
 */
export function PaywallModal({ open, onClose }: Props) {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Choose a FIG Verify plan"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 300,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center",
        overflowY: "auto",
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 520,
          minHeight: "100%",
          background: "hsl(var(--ink))",
        }}
      >
        <SubscriptionTiers paywall onClose={onClose} />
      </div>
    </div>
  );
}